import React from "react"
import type { SupportTicketStatus } from "../../types"

const STATUS: Record<SupportTicketStatus, { label: string; cls: string }> = {
  open: { label: "Aberto", cls: "bg-gold-400/20 text-gold-700" },
  answered: { label: "Respondido", cls: "bg-emerald-100 text-emerald-700" },
  closed: { label: "Fechado", cls: "bg-slate-200 text-navy-500" },
}

export function statusPill(status: SupportTicketStatus) {
  const s = STATUS[status]
  return <span className={`shrink-0 rounded-full px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}>{s.label}</span>
}
